import { render, staticRenderFns } from "./DateHumanView.vue?vue&type=template&id=0dfc7d70&scoped=true&"
import script from "./DateHumanView.vue?vue&type=script&lang=js&"
export * from "./DateHumanView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfc7d70",
  null
  
)

export default component.exports